var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.theaters.length)?_c('ul',{staticClass:"c-cards"},_vm._l((_vm.theaters),function(theater,index){return _c('Card',{key:theater.id,attrs:{"theater":theater,"index":index}})}),1):_c('div',{staticClass:"c-loading"},[_c('h1',[_vm._v("🗺 Loading …")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40f4b335","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards.vue
// module id = 72
// module chunks = 0